/**
 * Последним пользователь действовал клавиатурой (а не мышью или пальцем). Нужно подсказке и всему, что реагирует только на фокус с клавиатуры.
 * Radix открывает подсказку на любой фокус,
 * кроме фокуса от нажатия на сам триггер, — и на программный: раскрытый блок карточки ставит фокус на «Свернуть»,
 * и после клика мышью подсказка всплывала сама. Программный фокус показывает подсказку, только если перед ним была
 * клавиша: у клавиатуры фокус по-прежнему переносится и подписывается. Своё отслеживание, а не :focus-visible —
 * правила браузеров для программного фокуса расходятся, а jsdom их не знает (не проверить тестом).
 * Слушатели — одни на документ на всё время жизни страницы, как у самого :focus-visible.
 */
let lastInputKeyboard = false;
if (typeof document !== 'undefined') {
  document.addEventListener(
    'keydown',
    (e) => {
      // Сочетания (⌘Tab, Ctrl+C) — не переход по странице
      if (!e.metaKey && !e.ctrlKey && !e.altKey) lastInputKeyboard = true;
    },
    true
  );
  document.addEventListener(
    'pointerdown',
    () => {
      lastInputKeyboard = false;
    },
    true
  );
}

/** Последний ввод — клавиша (не мышь и не палец): фокус пришёл с клавиатуры */
export function lastInputWasKeyboard(): boolean {
  return lastInputKeyboard;
}
